var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M172.877 206.783c-6.622 11.354-18.786 19.081-32.877 19.081-14.082 0-26.255-7.727-32.867-19.08zM140 54.136c31.57 0 57.243 25.673 57.243 57.243v27.075c0 13.93 8.892 26.246 22.105 30.664l6.516 2.165v25.96H54.136v-25.96l6.525-2.165a32.3 32.3 0 0 0 22.096-30.664V111.38c0-31.57 25.683-57.243 57.243-57.243m0 19.08c-21.037 0-38.162 17.116-38.162 38.163v27.075a51.31 51.31 0 0 1-18.747 39.708h113.828a51.3 51.3 0 0 1-18.757-39.708V111.38c0-21.047-17.116-38.162-38.162-38.162"
})));
export default SvgNotification;